import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { ListingCard } from '@/components/ListingCard';
import { RESULTS } from '@/constants/testIds';

export const SourceGroup = ({ group }) => {
  const [open, setOpen] = useState(true);
  const count = group.count ?? group.listings.length;
  return (
    <section data-testid={RESULTS.sourceGroup} className="zita-card p-5 space-y-4">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between text-left"
      >
        <div className="flex items-center gap-3">
          <span className="font-serif text-2xl text-zita-espresso">{group.source_name}</span>
          <span className="text-sm text-zita-muted">{count} match{count !== 1 ? 'es' : ''}</span>
        </div>
        <ChevronDown size={18} className={`text-zita-mocha transition ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="space-y-4">
          {group.listings.map((l) => (
            <ListingCard key={l.id} listing={l} />
          ))}
        </div>
      )}
    </section>
  );
};
